import Vue from 'vue';

import template from 'raw-loader!./popupWrapper.html';

let popupWrapper = Vue.component('popup-wrapper', {
  name: 'popupWrapper',
  template: template,
  methods: {
    popupMaskClicked: function() {
      this.$emit('popup-mask-clicked');
    }
  }
});

export default popupWrapper;
